import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    id: 0,
    clienteId: 0,
    cliente: null,
    /*total: 0,*/
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    formaPagoId: 0,
    formaPago: null,
    formaPagoNombre: null,
    monedaId: 0,
    moneda: null,
    cotizacion: 0,
    cotizacionEnabled: Boolean(false),
    observaciones: '',

    cuentaCorriente: [],
    cuentaCorrienteDisplay: [],
    totalCuentaCorriente: 0,
    totalSeleccionado: 0,
    cantidadSeleccionados: 0,

    totalCuentaCorrientePesos: 0,
    totalSeleccionadoPesos: 0,
    totalCuentaCorrienteDolares: 0,
    totalSeleccionadoDolares: 0,

    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    formasPago: [],

    instruccionCobroDatos: [],
    instruccionCobroComprobantes: [],
    
    instruccionCobroDatosRpt: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_INSTRUCCION_COBRO' (state) {
        state.id = 0;
        state.clienteId = 0;
        state.cliente = null;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD');
        state.formaPagoId = 0;
        state.formaPago = null;
        state.formaPagoNombre = null;
        state.monedaId = 101;
        state.moneda = 'PESOS';
        state.cotizacion = 1;
        state.observaciones = '';

        state.cuentaCorriente= [];
        state.cuentaCorrienteDisplay = [];
        state.totalCuentaCorriente = 0;
        state.totalSeleccionado = 0;
        state.cantidadSeleccionados = 0;

        calcularTotalesCuentaCorriente(state);

        state.formasPago = [];
    },
    // 'SET_CLIENTE'(state, cliente) {
    //     state.cliente = cliente;
    //     if (cliente) {
    //         state.clienteId = cliente.id? cliente.id : 0;
    //         state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
    //     } else {
    //         state.clienteId = 0;
    //         state.clienteNombre = null;
    //     }
    // },
    'SET_CUENTA_CORRIENTE'(state, cuentaCorriente) {
        state.cuentaCorriente = [];
        state.cuentaCorrienteDisplay = [];

        state.cuentaCorriente = cuentaCorriente.map(cuentaCorriente => ({
            ...cuentaCorriente,
            selected: Boolean(false),
            seleccionDisabled: Boolean(false),
            _rowVariant: ''
        }))

        state.cuentaCorrienteDisplay = [...state.cuentaCorriente];

        state.paginaActual = 1;
        state.totalRegistros = state.cuentaCorrienteDisplay.length;

        calcularTotalesCuentaCorriente(state);

        state.monedaId = 0;
        state.moneda = null;
        state.cotizacion = 1;
    },
    'SELECCIONAR_CUENTA_CORRIENTE' (state, cuentaCorrienteId) {
        /* Buscamos la info del item seleccionado para filtrar los comprobantes */
        let item = state.cuentaCorriente
            .find(ccp => ccp.id == cuentaCorrienteId);

        if (item) {
            if (item.selected) {
                /* Seleccionamos los parametros de la instruccion de pago */
                state.clienteId = item.clienteId;
                state.cliente = item.cliente;

                if (state.monedaId == 0) {
                    state.monedaId= item.monedaId;
                    state.moneda = item.moneda;
                    state.cotizacion = 1;

                    if (state.monedaId == 101) {
                        state.cotizacionEnabled = Boolean(false);
                    } else {
                        state.cotizacionEnabled = Boolean(true);
                    }
                }
            }
        }

        calcularTotalesCuentaCorriente(state);

        if (!state.cantidadSeleccionados) {
            state.clienteId = 0;
            state.cliente = null;
            state.monedaId= 0;
            state.moneda = null;
            state.cotizacion = 0;
            state.cotizacionEnabled = Boolean(false);
        } 

        state.cuentaCorriente.forEach(cuentaCorriente => {
            let disabled = false;
            
            if (state.clienteId != 0 && cuentaCorriente.clienteId != state.clienteId) {
                disabled = true;
            } else {
                if (state.monedaId != 0 && cuentaCorriente.monedaId != state.monedaId) {
                    disabled = true;
                }
            }

            if (disabled) {
                cuentaCorriente.seleccionDisabled = true,
                cuentaCorriente._rowVariant = 'danger';
            } else {
                cuentaCorriente.seleccionDisabled = false,
                cuentaCorriente._rowVariant = '';
            }
        });

        state.cuentaCorrienteDisplay = [ ...state.cuentaCorriente.filter(t => t.seleccionDisabled == false) ];

        state.totalRegistros = state.cuentaCorrienteDisplay.length;
        if (state.paginaActual > state.totalPaginas) {
            state.paginaActual = 1;
        }
    },
    'CALCULAR_TOTAL_SELECCIONADO' (state) {
        calcularTotalesCuentaCorriente(state);
    },
    'SET_FORMA_PAGO'(state, formaPago) {
        state.formaPago = formaPago;
        if (formaPago) {
            state.formaPagoId = formaPago.id? formaPago.id : 0;
            state.formaPagoNombre = formaPago.nombre? formaPago.nombre.trim() : null;
        } else {
            state.formaPagoId = 0;
            state.formaPagoNombre = null;
        }
    },

    'VALIDAR_MONEDA' (state) {
        /* Si no hay comprobantes seleccionados, selecciono pesos como moneda */
        if (state.totalSeleccionadoPesos == 0 & state.totalSeleccionadoDolares == 0) {
            state.monedaId= 101;
            state.moneda = 'PESOS';
            state.cotizacion = 1;
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.instruccionCobroDatos = [];
        state.instruccionCobroComprobantes = [];
        state.instruccionCobroDatosRpt = [];
    },
    'SET_DATOS' (state, params) {
        state.instruccionCobroDatos = params.instruccionCobroDatos;
        state.instruccionCobroComprobantes = params.instruccionCobroComprobantes;
        
        state.instruccionCobroDatosRpt = params.instruccionCobroDatosRpt;
    },
};

function calcularTotalesCuentaCorriente (state) {
    state.totalSeleccionado = 0;
    state.cantidadSeleccionados = 0;

    state.totalCuentaCorrientePesos = 0;
    state.totalSeleccionadoPesos = 0;
    state.totalCuentaCorrienteDolares = 0;
    state.totalSeleccionadoDolares = 0;

    state.totalSeleccionado = state.cuentaCorriente
        .reduce((a, b) => a + ( b.selected ? b.saldo : 0 ), 0);

    state.cantidadSeleccionados = state.cuentaCorriente
        .reduce((a, b) => a + ( b.selected ? 1 : 0 ), 0);

    state.totalCuentaCorrientePesos = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 101 ? b.saldo : 0), 0);
    state.totalSeleccionadoPesos = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 101 & b.selected ? b.saldo : 0), 0);

    state.totalCuentaCorrienteDolares = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 102 ? b.saldo : 0), 0);
    state.totalSeleccionadoDolares = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 102 & b.selected ? b.saldo : 0), 0);
}

const getters = {
    getField,

    instruccionCobroDatosRpt(state) {
        return state.instruccionCobroDatosRpt;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INSTRUCCION_COBRO');

            apiAxios.get(`cuentacorrienteclientes/deuda`)
                .then(res => {
                    commit('SET_CUENTA_CORRIENTE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            if (save) {
                let selected = [];
                for(let key in state.cuentaCorrienteDisplay) {
                    let cuentaCorriente = state.cuentaCorrienteDisplay[key];
                    if ((/true/i).test(cuentaCorriente.selected)) {
                        let item = {
                            cuentaCorrienteClienteId: parseInt(cuentaCorriente.id),
                        }
                        selected.push(item);
                    }
                }

                let instruccionCobro= {
                    clienteId: parseInt(state.clienteId),
                    fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                    formaPagoId: parseInt(state.formaPagoId),
                    monedaId: parseInt(state.monedaId),
                    // cotizacion: parseFloat(state.cotizacion),
                    observaciones: state.observaciones.trim(),
                    renglones: selected,
                };

                apiAxios.post('instrucciones-cobros', instruccionCobro)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    calcularTotalSeleccionado ( { commit } ) {
        commit('CALCULAR_TOTAL_SELECCIONADO');
    },
    seleccionarCuentaCorriente ( { commit }, cuentaCorrienteId ) {
        return new Promise((resolve, reject) => {
            commit('SELECCIONAR_CUENTA_CORRIENTE', cuentaCorrienteId);
            resolve();
        })
    },
    setFormaPago ( { commit }, formaPago ) {
        return new Promise((resolve, reject) => {
            commit('SET_FORMA_PAGO', formaPago);
            resolve();
        })
    },
    validarMoneda ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('VALIDAR_MONEDA');
            resolve();
        })
    },

    getDatos ( { commit }, instruccionCobroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (instruccionCobroId) {
                apiAxios.get(`instrucciones-cobros/${instruccionCobroId}`) 
                    .then(res => {
                        let total = helpers.methods.formattedMoneda(res.data.total, res.data.monedaAbreviacion);
                        
                        let instruccionCobroDatos = [
                            { 'nombre': 'id', 'campo': 'Nro. Orden', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'formaPago', 'campo': 'Forma de Pago', 'valor': res.data.formaPago, 'formato': '' },
                            { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                        ]

                        let params = {
                            instruccionCobroDatos,
                            instruccionCobroComprobantes: res.data.comprobantes || [],
                            instruccionCobroDatosRpt: res.data
                        }
                                      
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}